export const rolesConfig = {
  dealer: {
    modules: [
      "dashboard",
      "customer",
      "customer-manager", // Guarantors
      "investor-report",
      "investor-statement",
      "investment-pool",
      "inventory-category",
      "inventory-system",
      "inventory",
      "sell-item-list",
      "branch-users",
      "accounts",
      "expenses",
      "contracts",
      "advance-options",
      "report",
    ],
    permissions: [
      "add_users",
      "edit_users",
      "delete_users",
      "edit_contracts",
      "delete_contracts",
      "edit_investors",
      "delete_investors",
      "view_reports",
      "add_customers",
      "edit_customers",
      "add_guarantors",
      "edit_guarantors",
      "add_investors",
      "add_contracts",
      "add_expenses",
      "edit_expenses",
      "delete_expenses",
    ]
  },
  manager: {
    modules: [
      "dashboard",
      "customer",
      "customer-manager",
      "investor-report",
      "investor-statement",
      "investment-pool",
      "inventory-category",
      "inventory-system",
      "inventory",
      "sell-item-list",
      "accounts",
      "expenses",
      "contracts",
      "report",
    ],
    permissions: [
      "view_reports",
      "add_customers",
      "edit_customers",
      "add_guarantors",
      "edit_guarantors",
      "add_investors",
      "add_contracts",
      "add_expenses",
      "edit_expenses",
    ]
  },
  staff: {
    modules: [
      "dashboard",
      "customer",
      "customer-manager",
      "investor-report",
      "investor-statement",
      "investment-pool",
      "inventory-category",
      "inventory-system",
      "inventory",
      "sell-item-list",
      "accounts",
      "expenses",
      "contracts",
    ],
    permissions: [
      "add_customers",
      "edit_customers",
      "add_guarantors",
      "edit_guarantors",
      "add_investors",
      "add_contracts",
      "add_expenses",
      "edit_expenses",
    ]
  }
};

export const hasPermission = (role, permission) => {
  if (role === "super") return true;
  return rolesConfig[role]?.permissions.includes(permission) || false;
};

export const hasModuleAccess = (role, moduleName) => {
  if (role === "super") return true;
  return rolesConfig[role]?.modules.includes(moduleName) || false;
};
